import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import styles from "./styles.module.css";
import { useNavigate } from 'react-router-dom';
import { NAVIGATION_ROUTES } from '../../constant';
import Loader from '../Loader';

const LanguageToggle: React.FC = () => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState<boolean>(false);

  // Function to change language and save it to localStorage
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng); // Save language preference
    setLoading(true);
    setTimeout(()=> {
      // navigate(NAVIGATION_ROUTES.SPLASH)
      window.location.reload();
    }, 1000)
  };

  // Load preferred language from localStorage or set default to English
  useEffect(() => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    } else {
      i18n.changeLanguage('en');
      localStorage.setItem('language', 'en');
    }
  }, [i18n]);

  if (loading) return <Loader/>
  return (
    <div className={clsx(styles.langToggleContainer)}>
      <div className={clsx(styles.label, "fontSizeSm14 fontWeightBold")}>
        {t('chooseLanguage')}
      </div>
      <div className={styles.btnBlock}>
        <button
          className={clsx(
            styles.langSwitchBtn,
            { [styles.active]: i18n.language === 'en' },
            "fontWeightBold fontSizeXs"
          )}
          onClick={() => changeLanguage('en')}
        >
          English
        </button>
        <button
          className={clsx(
            styles.langSwitchBtn,
            { [styles.active]: i18n.language === 'hi' },
            "fontWeightBold fontSizeXs"
          )}
          onClick={() => changeLanguage('hi')}
        >
          हिन्दी
        </button>
      </div>
    </div>
  );
};

export default LanguageToggle;
